// extracted by mini-css-extract-plugin
export var discard = "_33-3";
export var muiTooltipTooltip = "_33-5";
export var notificationBar = "_33-2";
export var saveButtonHoverSlotWrapper = "_33-4";
export var show = "_33-1";
export var spacer = "_33-0";